/* tslint:disable */
/* eslint-disable */
/**
 * Kiwi Framework
 * Kiwi API description
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AddFeatureRequest
 */
export interface AddFeatureRequest {
    /**
     * 
     * @type {string}
     * @memberof AddFeatureRequest
     */
    featureName: AddFeatureRequestFeatureNameEnum;
    /**
     * 
     * @type {string}
     * @memberof AddFeatureRequest
     */
    targetId: string;
    /**
     * 
     * @type {Date}
     * @memberof AddFeatureRequest
     */
    validUntil?: Date | null;
}


/**
 * @export
 */
export const AddFeatureRequestFeatureNameEnum = {
    QwenModel: 'QwenModel',
    TokenLimit: 'TokenLimit'
} as const;
export type AddFeatureRequestFeatureNameEnum = typeof AddFeatureRequestFeatureNameEnum[keyof typeof AddFeatureRequestFeatureNameEnum];


/**
 * Check if a given object implements the AddFeatureRequest interface.
 */
export function instanceOfAddFeatureRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "featureName" in value;
    isInstance = isInstance && "targetId" in value;

    return isInstance;
}

export function AddFeatureRequestFromJSON(json: any): AddFeatureRequest {
    return AddFeatureRequestFromJSONTyped(json, false);
}

export function AddFeatureRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddFeatureRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'featureName': json['featureName'],
        'targetId': json['targetId'],
        'validUntil': !exists(json, 'validUntil') ? undefined : (json['validUntil'] === null ? null : new Date(json['validUntil'])),
    };
}

export function AddFeatureRequestToJSON(value?: AddFeatureRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'featureName': value.featureName,
        'targetId': value.targetId,
        'validUntil': value.validUntil === undefined ? undefined : (value.validUntil === null ? null : value.validUntil.toISOString()),
    };
}

